import {useEffect, useState} from "react"
import Map from "./components/Map";
import {StatsCard} from "./components/StatsCard";
import {NewIncidents} from "./components/NewIncidents";
import FlashPointStats from "./components/FlashPointStats";
import {ChartColumnBig, MapPinned} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {useQuery} from '@tanstack/react-query';
import {fetchIncidents} from "../../api";

const authLocalStorageKey = "flash_report_isAuthenticated"

const statsData = {
    totalIncidents: 24,
    affectedConstituencies: 12
};

export const Dashboard = () => {
    const [tab, setTab] = useState("stats");
    const navigate = useNavigate();

    useEffect(() => {
        const isAthenticated = localStorage.getItem(authLocalStorageKey)
        if (!isAthenticated) {
            navigate("/login")
        }
        // eslint-disable-next-line
    }, [])
    //Use react-query for near realtime update.
    const {data: incidences} = useQuery({
        queryKey: ['todos'],
        queryFn: fetchIncidents,
        refetchInterval: 5000,
        refetchIntervalInBackground: true,
        staleTime: 0
    })
    return (
        <div className={"flex"}>
            <div className="bg-gray-100 w-[10%] cursor-pointer">
                <div className={`flex  p-4 items-center cursor-pointer ${tab === "stats" ? 'bg-gray-400' : ''}`}
                     onClick={() => setTab("stats")}>
                    <ChartColumnBig/>
                    <p className="px-2">Stats</p>
                </div>
                <div className={`flex p-4 items-center cursor-pointer ${tab === "map" ? 'bg-gray-400' : ''}`}
                     onClick={() => setTab("map")}>
                    <MapPinned/>
                    <p className="px-2">Map</p>
                </div>
                <div className="mt-20 mx-auto">
                    <p className={"cursor-pointer text-blue-900 p-4"} onClick={() => {
                        localStorage.removeItem(authLocalStorageKey)
                        navigate("/login")
                    }}>Logout</p>
                </div>

            </div>
            <div className="w-full">
                {tab === "stats" && <div className="grid grid-cols-2">
                    <div>
                        <StatsCard stats={statsData}/>
                        <NewIncidents newIncidence={(incidences || []).slice(0, 3)}/>
                    </div>

                    <FlashPointStats/>
                </div>
                }
                {tab === "map" && <div className="h-[500px] md:h-[100vh] w-full">
                    <Map incidences={incidences || []}/>
                </div>}
            </div>
        </div>

    );
};
